// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"53766b59","366":"1c266858","686":"7434fd84","860":"210252a7","938":"f1691600"}[chunkId] + ".chunk.js";
};